module.exports = __webpack_public_path__ + "static/img/coin2.f84ef53.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/coin2.png
// module id = c6zU
// module chunks = 0